import type { RefObject } from 'react';
import { useEffect, useState } from 'react';
import type { BlockProps } from '../../types';

const MEDIA_BANNER_LAYOUTS = ['embeddedBanner', 'leftBanner', 'rightBanner'];

interface UseOuterMarginProps {
  backgroundRef: RefObject<HTMLDivElement | null>;
  blocks: BlockProps[] | undefined;
  bannerWidth: number | undefined;
  contentHorizontalPadding: number;
  stretchBackground: boolean;
}

export function useOuterMargin({
  backgroundRef,
  blocks,
  bannerWidth,
  contentHorizontalPadding,
  stretchBackground
}: UseOuterMarginProps) {
  const [stretchedPadding, setStretchedPadding] = useState(
    contentHorizontalPadding
  );

  useEffect(() => {
    const handleWindowResize = () => {
      if (!blocks) {
        return;
      }

      const background = backgroundRef?.current;

      const hasBannerBlocks = blocks.some(({ type, layout }) => {
        if (type === 'image' || type === 'video') {
          return MEDIA_BANNER_LAYOUTS.includes(layout);
        }

        return false;
      });

      if (
        !background ||
        !stretchBackground ||
        !bannerWidth ||
        !hasBannerBlocks
      ) {
        return;
      }

      const padding = Math.round((background.offsetWidth - bannerWidth) / 2);

      setStretchedPadding(Math.max(contentHorizontalPadding, padding));
    };

    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, [backgroundRef, blocks, stretchBackground, bannerWidth]);

  return stretchedPadding;
}
